import { TFunction } from 'i18next';

import { SidebarIcons } from '../icons';
import { MenuItem } from '../types';

/**
 * Preview menu shown when the user has no assigned client. All items are
 * disabled but visible so the user can preview the platform shape.
 */
const buildLockedMenu = (t: TFunction): MenuItem[] => [
  { key: 'preview-monitor', label: t('Sidebar.Monitor'), icon: SidebarIcons.dashboard, link: '#', enabled: false },
  { key: 'preview-agent', label: 'Agent', icon: SidebarIcons.agent, link: '#', enabled: false },
  { key: 'preview-suppliers', label: t('Sidebar.Suppliers'), icon: SidebarIcons.suppliers, link: '#', enabled: false },
  {
    key: 'preview-manual-upload',
    label: t('Sidebar.ManualUpload'),
    icon: SidebarIcons.users,
    link: '#',
    enabled: false,
  },
  {
    key: 'preview-integrations',
    label: t('Sidebar.Integrations'),
    icon: SidebarIcons.integrations,
    link: '#',
    enabled: false,
  },
  {
    key: 'preview-credentials',
    label: t('Sidebar.Credentials'),
    icon: SidebarIcons.credentials,
    link: '#',
    enabled: false,
  },
  {
    key: 'preview-documentation',
    label: t('Sidebar.Documentation'),
    icon: SidebarIcons.documentation,
    link: '#',
    enabled: false,
  },
  { key: 'preview-users', label: t('Sidebar.Users'), icon: SidebarIcons.users, link: '#', enabled: false },
];

export default buildLockedMenu;
